import firebase from"firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC6uaLkDZiSdVx-qmiE825PDG7KyaiGfZ8",
  authDomain: "clone-22bd4.firebaseapp.com",
  projectId: "clone-22bd4",
  storageBucket: "clone-22bd4.appspot.com",
  messagingSenderId: "755922096148",
  appId: "1:755922096148:web:bfd87c113e134684335701",
  measurementId: "G-7PYNWH269X"
};
const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export {db,auth};